import Clear from '@/layouts/Clear.vue';

export default {
  path: '/clinics',
  component: Clear,
  children: [
    {
      path: '',
      name: 'clinics.index',
      component: () => import('@/views/Clinic/ClinicsList.vue'),
    },
    {
      path: ':id?',
      name: 'clinics.save',
      component: () => import('@/views/Clinic/Clinic.vue'),
    },
  ],
};
